import {
  MAX_UPLOAD_FILE_SIZE_MB,
  VIDEOS_MIME_TYPES,
  IMAGES_MIME_TYPES,
  OTHER_MIME_TYPES,
  ALLOWED_IMAGES_EXTS,
  ALLOWED_VIDEOS_EXTS,
  ALLOWED_OTHER_EXTS
} from '../constants/files'

const BYTES_IN_MB = 1048576

export default {
  data() {
    return {
      dragoverMixin: false,
      errorMixin: null,
      uploadFileMethodNameMixin: [],
      maxSizeMixin: MAX_UPLOAD_FILE_SIZE_MB,
      allowedFilesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS, ...ALLOWED_OTHER_EXTS],
      allowedFilesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES, ...OTHER_MIME_TYPES]
    }
  },
  computed: {},
  methods: {
    onDragoverMixin(e) {
      e.preventDefault()
    },
    onDragenterMixin(e) {
      e.preventDefault()
      this.dragoverMixin = true
    },
    onDragleaveMixin(e) {
      e.preventDefault()
      // console.log('do')
      this.dragoverMixin = false
    },
    onDropMixin(e) {
      e.preventDefault();
      this.dragoverMixin = false
      const files = e.dataTransfer.files;
      this.uploadFileMixin(files);
    },
    onFilesInputMixin(event) {
      const files = event.target.files
      if (files && files.length) {
        this.uploadFileMixin(files)
      }

      event.target.value = null
    },
    uploadFileMixin(files) {
      this.errorMixin = null
      if (!this.moderateFilesMixin(files)) return

      for (let method of this.uploadFileMethodNameMixin) {
        if (typeof this[method] === 'function') {
          this[method](files)
        }
      }
    },
    getExtFromNameMixin(filename) {
      let idx = filename.lastIndexOf('.');
      return (idx < 1) ? '' : filename.substr(idx + 1);
    },
    moderateFilesMixin(files) {
      this.errorMixin = null

      for (const file of files) {
        if (!this.checkFileFormatMixin(file)) {
          this.errorMixin = [
            'You are trying to upload not allowed files formats.',
            'Allowed file formats: ' + this.allowedFilesExtsMixin.join(', ')
          ]
          return false
        }

        if (!this.checkFileSizeMixin(file)) {
          this.errorMixin = [
            'File is too large',
            `Maximum files size is ${this.maxSizeMixin}Mb`
          ]
          return false
        }
      }

      return true
    },
    checkFileFormatMixin(file) {
      // let ext = this.getExtFromNameMixin(file.name)
      // if (!this.allowedFilesExtsMixin.includes(ext)) {
      //   return false
      // }
      //
      // ext = file.type.split('/')
      // ext = ext[ext.length - 1]
      //
      // if (!this.allowedFilesExtsMixin.includes(ext)) {
      //   return false
      // }
      if(!file.type) return true
      return this.allowedFilesMimeTypes.includes(file.type)
    },
    checkFileSizeMixin(file) {
      let sizeMb = file.size / BYTES_IN_MB
      return !(sizeMb > this.maxSizeMixin)
    }
  },
  mounted() {
    const dropzone = this.$refs['dropzone']
    if (!dropzone) return

    dropzone.addEventListener('dragover', this.onDragoverMixin)
    dropzone.addEventListener('dragenter', this.onDragenterMixin)
    dropzone.addEventListener('dragleave', this.onDragleaveMixin)
    dropzone.addEventListener('drop', this.onDropMixin)
  },
  beforeDestroy() {
    const dropzone = this.$refs['dropzone']
    if (!dropzone) return

    dropzone.removeEventListener('dragover', this.onDragoverMixin)
    dropzone.removeEventListener('dragenter', this.onDragenterMixin)
    dropzone.removeEventListener('dragleave', this.onDragleaveMixin)
    dropzone.removeEventListener('drop', this.onDropMixin)
  }
}
